(ns ui.components.combobox.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Combobox/styles.json
;; Source commit: 788b812929c721329dd09dfa556d0786c59e564d
;; ----------------------------------------------------------------------------

(def combobox
  {:description
   {:base "tw2-mt-0.5 tw2-block tw2-text-tertiary tw2-text-helper",
    :compound-variants [],
    :default-variants {}},
   :_meta
   {:tokens
    ["body-md-font-size"
     "body-md-font-weight"
     "body-md-line-height"
     "dropdown-bg-default"
     "dropdown-bg-disabled"
     "dropdown-bg-focus"
     "dropdown-bg-hover"
     "dropdown-bg-item-danger-hover"
     "dropdown-bg-item-danger-pressed"
     "dropdown-bg-item-hover"
     "dropdown-bg-pressed"
     "dropdown-border-default"
     "dropdown-border-disabled"
     "dropdown-border-hover"
     "dropdown-border-pressed"
     "dropdown-list-bg"
     "field-bg-default"
     "field-bg-disabled"
     "field-bg-error"
     "field-bg-error-focus"
     "field-bg-error-hover"
     "field-bg-error-pressed"
     "field-bg-focus"
     "field-bg-hover"
     "field-bg-pressed"
     "field-border-default"
     "field-border-disabled"
     "field-border-error"
     "field-border-error-hover"
     "field-border-error-pressed"
     "field-border-hover"
     "field-border-pressed"
     "field-placeholder-text"
     "field-ring-error"
     "field-ring-focus"
     "field-text-disabled"
     "helper-font-size"
     "helper-font-weight"
     "helper-line-height"
     "radius-dropdown"
     "radius-field"
     "spacing-dropdown-gap"
     "spacing-dropdown-list-gap"
     "spacing-dropdown-list-px"
     "spacing-dropdown-list-py"
     "spacing-dropdown-px"
     "spacing-dropdown-py"
     "spacing-field-px"
     "text-disabled"
     "text-error"
     "text-primary"
     "text-secondary"
     "text-tertiary"
     "z-modal-overlay"],
    :generated-from "src/components/Combobox/Combobox.styles.ts",
    :a11y
    ["Search input has role=\"combobox\", aria-expanded, aria-controls, aria-autocomplete=\"list\", and aria-activedescendant pointing at the active option."
     "ArrowDown and ArrowUp move the active option and skip disabled options. Home and End jump to the first and last option."
     "Enter in the search selects the active option. Opening with ArrowDown, Enter, or Space moves to the selected option, or the first."
     "Escape closes and returns focus to the trigger. Tab closes."
     "The active option uses the item hover background."]},
   :chevron-down
   {:base
    "tw2-absolute tw2-inset-0 tw2-w-4 tw2-h-4 tw2-text-tertiary tw2-transition-all tw2-duration-300 tw2-ease-in-out",
    :open
    {:true "tw2-opacity-0 tw2-rotate-180 tw2-scale-75",
     :false "tw2-opacity-100 tw2-rotate-0 tw2-scale-100"},
    :compound-variants [],
    :default-variants {:open false}},
   :search-icon-wrap
   {:base
    "tw2-absolute tw2-left-3 tw2-top-1/2 tw2-transform tw2--translate-y-1/2 tw2-w-4 tw2-h-4 tw2-flex tw2-items-center tw2-justify-center",
    :compound-variants [],
    :default-variants {}},
   :item-label
   {:base "tw2-block tw2-truncate",
    :compound-variants [],
    :default-variants {}},
   :check
   {:base "tw2-w-4 tw2-h-4 tw2-ml-2",
    :tone
    {:default "tw2-text-secondary",
     :danger "tw2-text-error",
     :disabled "tw2-text-disabled"},
    :compound-variants [],
    :default-variants {:tone "default"}},
   :item
   {:base
    "tw2-w-full tw2-px-dropdown-px tw2-py-dropdown-py tw2-font-sans tw2-text-left tw2-text-body-md hover:tw2-rounded-dropdown tw2-flex tw2-items-center tw2-justify-between",
    :variant
    {:default "tw2-text-secondary",
     :danger "tw2-text-error",
     :disabled "tw2-text-disabled"},
    :selected {:true "tw2-rounded-dropdown", :false ""},
    :highlighted {:true "", :false ""},
    :disabled {:true "tw2-opacity-50 tw2-cursor-not-allowed", :false ""},
    :compound-variants
    [{:variant "default",
      :disabled false,
      :class "hover:tw2-bg-dropdown-bg-item-hover"}
     {:variant "danger",
      :disabled false,
      :class
      "hover:tw2-bg-dropdown-bg-item-danger-hover active:tw2-bg-dropdown-bg-item-danger-pressed"}
     {:selected true,
      :highlighted false,
      :class "tw2-bg-dropdown-bg-focus"}
     {:highlighted true,
      :variant "default",
      :class "tw2-bg-dropdown-bg-item-hover tw2-rounded-dropdown"}
     {:highlighted true,
      :variant "danger",
      :class "tw2-bg-dropdown-bg-item-danger-hover tw2-rounded-dropdown"}
     {:highlighted true,
      :variant "disabled",
      :class "tw2-bg-dropdown-bg-item-hover tw2-rounded-dropdown"}],
    :default-variants
    {:variant "default",
     :selected false,
     :highlighted false,
     :disabled false}},
   :search-icon
   {:base "tw2-w-4 tw2-h-4 tw2-text-tertiary",
    :compound-variants [],
    :default-variants {}},
   :chevron-up
   {:base
    "tw2-absolute tw2-inset-0 tw2-w-4 tw2-h-4 tw2-text-tertiary tw2-transition-all tw2-duration-300 tw2-ease-in-out",
    :open
    {:true "tw2-opacity-100 tw2-rotate-0 tw2-scale-100",
     :false "tw2-opacity-0 tw2--rotate-180 tw2-scale-75"},
    :compound-variants [],
    :default-variants {:open false}},
   :search
   {:base
    "tw2-px-dropdown-list-px tw2-pt-dropdown-list-py tw2-pb-2 tw2-border-b tw2-border-dropdown-border-default",
    :compound-variants [],
    :default-variants {}},
   :empty
   {:base "tw2-text-tertiary tw2-text-body-md",
    :compound-variants [],
    :default-variants {}},
   :trigger-label
   {:base "tw2-truncate", :compound-variants [], :default-variants {}},
   :search-field-wrap
   {:base "tw2-relative", :compound-variants [], :default-variants {}},
   :list
   {:base
    "tw2-absolute tw2-left-0 tw2-right-0 tw2-mt-1 tw2-rounded-dropdown hover:tw2-rounded-dropdown tw2-shadow-xs tw2-bg-dropdown-list-bg tw2-border tw2-border-dropdown-border-default tw2-z-modal-overlay tw2-overflow-hidden tw2-flex tw2-flex-col tw2-transition-all tw2-duration-200 tw2-ease-out tw2-origin-top",
    :visible
    {:true "tw2-opacity-100 tw2-translate-y-0 tw2-scale-y-100",
     :false
     "tw2-opacity-0 tw2--translate-y-4 tw2-scale-y-95 tw2-pointer-events-none"},
    :compound-variants [],
    :default-variants {:visible false}},
   :root
   {:base "tw2-relative tw2-w-full",
    :compound-variants [],
    :default-variants {}},
   :search-field
   {:base
    "tw2-w-full tw2-px-field-px tw2-text-body-md tw2-border tw2-rounded-field tw2-transition-all tw2-duration-150 tw2-ease-out focus-visible:tw2-outline-none focus-visible:tw2-ring-2 disabled:tw2-pointer-events-none disabled:tw2-cursor-not-allowed placeholder:tw2-text-field-placeholder-text tw2-pl-10 tw2-pr-3 tw2-py-2",
    :state
    {:default
     "tw2-bg-field-bg-default tw2-border-field-border-default tw2-text-primary tw2-shadow-xs hover:tw2-bg-field-bg-hover hover:tw2-border-field-border-hover hover:tw2-shadow-sm active:tw2-bg-field-bg-pressed active:tw2-border-field-border-pressed active:tw2-shadow-xs focus-visible:tw2-bg-field-bg-focus focus-visible:tw2-border-field-border-pressed focus-visible:tw2-ring-2 focus-visible:tw2-ring-field-ring-focus focus-visible:tw2-ring-offset-0 focus-visible:tw2-outline-none focus-visible:tw2-outline-offset-0",
     :error
     "tw2-bg-field-bg-error tw2-border-field-border-error tw2-text-primary tw2-shadow-xs hover:tw2-bg-field-bg-error-hover hover:tw2-border-field-border-error-hover hover:tw2-shadow-sm active:tw2-bg-field-bg-error-pressed active:tw2-border-field-border-error-pressed active:tw2-shadow-xs focus-visible:tw2-bg-field-bg-error-focus focus-visible:tw2-border-field-border-error-pressed focus-visible:tw2-ring-2 focus-visible:tw2-ring-field-ring-error focus-visible:tw2-ring-offset-0 focus-visible:tw2-outline-none focus-visible:tw2-outline-offset-0",
     :disabled
     "tw2-bg-field-bg-disabled tw2-border-field-border-disabled tw2-text-field-text-disabled tw2-cursor-not-allowed tw2-opacity-50 tw2-shadow-none focus-visible:tw2-ring-offset-2"},
    :compound-variants [],
    :default-variants {:state "default"}},
   :chevron
   {:base "tw2-relative tw2-w-4 tw2-h-4",
    :compound-variants [],
    :default-variants {}},
   :options
   {:base
    "tw2-px-dropdown-list-px tw2-py-dropdown-list-py tw2-max-h-[200px] tw2-overflow-y-auto tw2-flex tw2-flex-col tw2-gap-dropdown-list-gap",
    :compound-variants [],
    :default-variants {}},
   :trigger
   {:base
    "tw2-w-full tw2-min-w-0 tw2-inline-flex tw2-items-center tw2-justify-between tw2-gap-dropdown-gap tw2-px-dropdown-px tw2-py-dropdown-py tw2-rounded-dropdown tw2-text-left tw2-font-sans tw2-text-body-md tw2-transition-colors tw2-duration-150 tw2-border tw2-relative focus:tw2-bg-dropdown-bg-focus focus:tw2-border-dropdown-border-pressed active:tw2-bg-dropdown-bg-pressed focus-visible:tw2-outline-none focus-visible:tw2-ring-2 focus-visible:tw2-ring-field-ring-focus focus-visible:tw2-ring-offset-0",
    :state
    {:default
     "tw2-bg-dropdown-bg-default tw2-border-dropdown-border-default tw2-shadow-xs hover:tw2-bg-dropdown-bg-hover hover:tw2-border-dropdown-border-hover hover:tw2-shadow-sm",
     :hover
     "tw2-bg-dropdown-bg-hover tw2-border-dropdown-border-hover tw2-shadow-sm tw2-text-primary",
     :active
     "tw2-bg-dropdown-bg-pressed tw2-border-dropdown-border-pressed tw2-shadow-xs tw2-text-primary",
     :focus
     "tw2-bg-dropdown-bg-focus tw2-border-dropdown-border-pressed tw2-shadow-xs tw2-text-primary",
     :disabled
     "tw2-bg-dropdown-bg-disabled tw2-border-dropdown-border-disabled tw2-shadow-xs tw2-cursor-not-allowed tw2-opacity-50"},
    :selected {:true "", :false ""},
    :compound-variants
    [{:state "default",
      :selected false,
      :class "tw2-text-field-placeholder-text"}
     {:state "default", :selected true, :class "tw2-text-primary"}
     {:state "disabled", :selected false, :class "tw2-text-disabled"}
     {:state "disabled", :selected true, :class "tw2-text-primary"}],
    :default-variants {:state "default", :selected false}},
   :item-body
   {:base "tw2-min-w-0 tw2-text-left",
    :compound-variants [],
    :default-variants {}}})
